// extracted by mini-css-extract-plugin
export default {"title":"AlertModule_title__C2vl+","text":"AlertModule_text__mFA7Z","ctaButton":"AlertModule_ctaButton__ZnIbw"};